import {FC} from 'react';
//store
import {useAppSelector} from '@/store/hooks';
import {getEventTotoListSelector} from '@/store/organization-event';
//mui
import {Box, Typography} from '@mui/material';
import {useNavigate} from 'react-router-dom';
//icons
import {ReactComponent as ArrowLineRightIcon} from '@/assets/icons/arrow-line-right.svg';
//types
import {IEventTodoList} from '@/utils/types';
//constants
import {TODO_LIST} from '@constants/dashboard';
import {CAPTION, SEE_ALL, SUBTITLE1, TEXT} from '@/utils/constants';
//enums
import {ROUTER_URL} from '@/utils/enums';
//components
import Button from '@components/Button';
import TodoItem from '@/components/Organization/Dashboard/TodoList/TodoItem';
//styles
import {todoListStyle} from './TodoList.styles';
import {createTodoData} from '@/pages/Organization/Dashboard/TodoListPage';

const TodoList: FC = () => {
	const navigate = useNavigate();

	const todoList: IEventTodoList[] = useAppSelector(getEventTotoListSelector);

	const navigateToAllTodos = () => navigate(ROUTER_URL.ORGANIZATION_DASHBOARD_TODO_LIST);

	return (
		<Box sx={todoListStyle.wrapper}>
			<Box sx={todoListStyle.header}>
				<Typography variant={SUBTITLE1}>{TODO_LIST}</Typography>

				<Typography sx={todoListStyle.amount} variant={CAPTION}>
					{todoList.length} of {createTodoData.length} remaining
				</Typography>

				<Button onClick={navigateToAllTodos} variant={TEXT} title={SEE_ALL} endIcon={<ArrowLineRightIcon />} />
			</Box>

			<Box>
				{todoList.map((todoItem) => (
					<TodoItem todoItem={todoItem} key={todoItem.id} />
				))}
			</Box>
		</Box>
	);
};

export default TodoList;
